import { Component, Input, Output, EventEmitter, OnChanges } from '@angular/core';
import { AffiliatorRestService } from '../../main/affiliator/affiliator-rest.service';

@Component({
  selector: 'app-image-preview',
  templateUrl: './image-preview.component.html',
  styleUrls: ['./image-preview.component.scss']
})
export class ImagePreviewComponent implements OnChanges {
  @Input() visible: boolean = false;
  @Output() visibleChange = new EventEmitter<boolean>();

  @Input() title: string = '';
  @Input() file: any = null;

  imageUrl: string = '';
  loading: boolean = false;

  constructor(private _affiliatorRest: AffiliatorRestService) {}

  ngOnChanges() {
    if (this.visible && this.file) {
      this.resolveImageUrl(this.file);
    }
  }

  resolveImageUrl(file: any) {
    // If file is a string and starts with http:// or https://, assign directly
    if (typeof file === 'string' && (file.startsWith('http://') || file.startsWith('https://'))) {
      this.imageUrl = file;
      this.loading = false;
      return;
    } else {
      const payload = { storageFileName: file };
      this._affiliatorRest.getPresignedUrl(payload).subscribe({
        next: (data) => {
          this.imageUrl = data.url;
          this.loading = false;
        },
        error: () => {
          this.imageUrl = '';
          this.loading = false;
        }
      });
    }
  }

  close() {
    this.visible = false;
    this.visibleChange.emit(false); // ⬅️ Ini penting!
    this.imageUrl = '';
  }
}
